import React, { useState, useEffect } from "react";
import List from "../../styledComponents/Table/List";
import plaidIcon from "../../../assets/images/budget/plaidlogo.png";
import Tab, { TabItem } from "../../Budget/BudgetComponents/SettingTabs/Tabs";
import moment from "moment";

export const BudgetReportList = ({ categorySum, filteredReport, tabName }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const onTabSelected = (index) => {
    const selectedTabName = getTabNameByIndex(index);
    setSelectedTab(selectedTabName);
    setSelectedIndex(index);
  };
  const getTabNameByIndex = (index) => {
    if (index >= 0 && index < filteredTabs.length) {
      return filteredTabs[index];
    } else {
      return null;
    }
  };
  const categoryCols = [
    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div>
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Total",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "black"
                : "#00A27B",
          }}
        >
        {record.amount
          ? !isNaN(record.amount)
            ? `${
                "$" +
                (record.typeOfTransaction === "Expense"
                  ? record.amount < 0
                    ? record.amount.toFixed(2) // Keep negative if already negative
                    : (record.amount * -1).toFixed(2) // Otherwise, make negative
                  : record.typeOfTransaction === "Income"
                  ? record.amount > 0
                    ? record.amount.toFixed(2) // Keep positive if already positive
                    : (record.amount * -1).toFixed(2) // Otherwise, make positive
                  : record.amount < 0
                  ? record.amount.toFixed(2) // If amount is negative and no type, show as positive
                  : record.amount.toFixed(2)
                ) // Positive to negative
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }`
            : "N/A"
          : "N/A"}
        </div>
      ),
    },
  ];
  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "Item Name",
      dataIndex: "itemName",
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              style={{ borderRadius: "50%" }}
              height={34}
              width={34}
              src={record.itemLogo ? record.itemLogo : plaidIcon}
            ></img>
            <div>{record.itemName}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div>
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "black"
                : "#00A27B",
          }}
        >
        {record.amount
          ? !isNaN(record.amount)
            ? `${
                "$" +
                (record.typeOfTransaction === "Expense"
                  ? record.amount < 0
                    ? record.amount.toFixed(2) // Keep negative if already negative
                    : (record.amount * -1).toFixed(2) // Otherwise, make negative
                  : record.typeOfTransaction === "Income"
                  ? record.amount > 0
                    ? record.amount.toFixed(2) // Keep positive if already positive
                    : (record.amount * -1).toFixed(2) // Otherwise, make positive
                  : record.amount < 0
                  ? record.amount.toFixed(2) // If amount is negative and no type, show as positive
                  : record.amount.toFixed(2)
                ) // Positive to negative
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }`
            : "N/A"
          : "N/A"}
        </div>
      ),
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      // sorter: (a, b) => a["bankName"] > b["bankName"],
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
            <div>{record.bankName}</div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Type of Transaction",
      dataIndex: "typeOfTransaction",
      sorter: (a, b) =>
        (a.typeOfTransaction || "").localeCompare(b.typeOfTransaction || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
      render: (record) => (record ? record : "N/A"),
    },
  ];

  const updateBanksData = (banksData) => {
    const new_banksData = [];
    if (banksData) {
      for (const data of banksData) {
        if (data.accountName) {
          // Check if bankName exists
          new_banksData.push({
            ...data,
            // tabName: data.bankName + " " + data.accountType,
            // tabName: data.accountName,
            tabName:
              data.accountName + "_" + data.bankName + data.accountNumber,
          });
        } else {
          new_banksData.push(data);
        }
      }
      return new_banksData;
    }
  };
  const updatedBanksData = updateBanksData(
    filteredReport && filteredReport ? filteredReport : []
  );

  const updateCategoryBanksData = (banksData) => {
    const new_banksData = [];
    if (banksData) {
      for (const data of banksData) {
        if (data.accountName) {
          // Check if bankName exists
          new_banksData.push({
            ...data,
            // tabName: data.bankName + " " + data.accountType,
            // tabName: data.accountName,
            tabName:
              data.accountName + "_" + data.bankName + data.accountNumber,
          });
        } else {
          new_banksData.push(data);
        }
      }
      return new_banksData;
    }
  };
  const updatedCategoryBanksData = updateCategoryBanksData(
    categorySum && categorySum ? categorySum : []
  );
  const filteredTabs = [
    "All",
    ...new Set(
      updatedBanksData && updatedBanksData.map((item) => item.tabName)
    ),
  ];

  const filterDataByTab = () => {
    if (updatedBanksData && selectedTab) {
      let data;
      if (selectedTab === "All") {
        data = updatedBanksData;
      } else {
        data = updatedBanksData.filter((item) => item.tabName === selectedTab);
      }
      setSelectedData(data);
    }
  };
  const filterCategoryDataByTab = () => {
    if (updatedCategoryBanksData && selectedTab) {
      let data;
      if (selectedTab === "All") {
        data = updatedCategoryBanksData;
      } else {
        data = updatedCategoryBanksData.filter(
          (item) => item.tabName === selectedTab
        );
      }
      return data;
      //   setSelectedData(data);
    }
  };
  useEffect(() => {
    if (selectedTab && selectedTab !== "All") {
      filterDataByTab();
    } else if (filteredReport && filteredReport) {
      setSelectedData(filteredReport);
    } else {
      setSelectedData([]);
    }
  }, [selectedTab, filteredReport, tabName]);

  return (
    <div>
      {tabName !== 0 && (
        <React.Fragment>
          {tabName !== 0 &&
            filteredTabs &&
            filteredTabs.length > 0 && (
              <div className="TabSection">
                <Tab
                  onTabSelected={onTabSelected}
                  selectedIndex={selectedIndex}
                >
                  {filteredTabs.map((tab, index) => {
                    const accountName =
                      tab && tab.includes("_") ? tab.split("_")[0] : tab;
                    return <TabItem key={index}>{accountName}</TabItem>;
                  })}
                </Tab>
              </div>
            )}
        </React.Fragment>
      )}
      <div className="tableSection">
        <div className="leftTable">
          <div className="reportCardTitle">Category Data</div>
          <List
            cols={categoryCols}
            rows={tabName === 0 ? categorySum : filterCategoryDataByTab()}
          ></List>
        </div>
        <div className="rightTable">
          <div className="reportCardTitle">Transaction Data</div>
          <List
            cols={cols}
            rows={tabName === 0 ? filteredReport : selectedData}
          ></List>
        </div>
      </div>
    </div>
  );
};
